import React from 'react';
import PropTypes from 'prop-types';

import { isNil } from 'lodash';

import {
    ContentZonesService,
    LocaleService,
    WindowProxy,
    ConfigsService,
    UrlService,
} from '@sm360/widget-commons-core-services';
import { CONSTANT, REDIRECTIONS, EVENTS, AdobeService, ADOBE_TAGS } from '@sm360/widget-commons-general';
import { CurrencyFormats, ORGANIZATIONS } from '@sm360/widget-commons-vehicle';
// TODO: Put this back with official trade-in into CRM import { CurrencyFormats } from 'commons-vehicle';

import GarageContainer from 'login/components/Transaction/TransactionActionDetails/GarageContainer.jsx';
import TransactionActionDetails from 'login/components/Transaction/TransactionActionDetails/TransactionActionDetails.jsx';
import FinancingState from 'login/components/Transaction/TransactionAction/TransactionFinancingState/TransactionFinancingState.jsx';

import 'login/components/Transaction/TransactionAction/TransactionAction.scss';

const czGroup = 'widget.transaction';
class TransactionAction extends React.Component {
    constructor(props) {
        super(props);
        this.onTradeInClick = this.onTradeInClick.bind(this);
        this.actionHandleClick = this.actionHandleClick.bind(this);
        this.renderGarageSection = this.renderGarageSection.bind(this);
        this.renderTradeInSection = this.renderTradeInSection.bind(this);
        this.renderFinanceSection = this.renderFinanceSection.bind(this);
        this.renderReservationSection = this.renderReservationSection.bind(this);

        const organizationId = ConfigsService.getOrganizationId();

        this.state = {
            displayNewTradeIn:
                (UrlService.getUrlParameter('newTradeIn') && UrlService.getUrlParameter('newTradeIn') === 'true') ||
                organizationId === ORGANIZATIONS.DILAWRI,
            forceVehiclesFetch: false,
        };
    }

    componentDidMount() {
        const $window = WindowProxy.get();
        if ($window) {
            $window.document.addEventListener(EVENTS.DEPOSIT_COMPLETED, () =>
                this.setState({ forceVehiclesFetch: true })
            );
        }
    }

    componentWillUnmount() {
        const $window = WindowProxy.get();

        if ($window) {
            $window.document.removeEventListener(EVENTS.DEPOSIT_COMPLETED, () =>
                this.setState({ forceVehiclesFetch: true })
            );
        }
    }

    onTradeInClick(isOfficial) {
        const windowProxy = WindowProxy.get();
        const locale = LocaleService.getSimpleLocale();
        if (windowProxy) {
            if (isOfficial) {
                if (this.props.hasAdobeTagging) {
                    AdobeService.eventTrigger(
                        ADOBE_TAGS.TRANSACTION_BAR_CTA(
                            CONSTANT.TRANSACTION.TRADEIN.TITLE,
                            CONSTANT.TRANSACTION.TRADEIN.OFFICIAL
                        ),
                        'global-onclick'
                    );
                }
                windowProxy.location.href = REDIRECTIONS[locale].tradeInOfficial;
            } else {
                if (this.props.hasAdobeTagging) {
                    AdobeService.eventTrigger(
                        ADOBE_TAGS.TRANSACTION_BAR_CTA(
                            CONSTANT.TRANSACTION.TRADEIN.TITLE,
                            CONSTANT.TRANSACTION.TRADEIN.INSTANT
                        ),
                        'global-onclick'
                    );
                }
                windowProxy.location.href = this.state.displayNewTradeIn
                    ? REDIRECTIONS[locale].tradeInEstimatedDilawri
                    : REDIRECTIONS[locale].tradeInEstimated;
            }
        }
    }

    actionHandleClick(itemSlug) {
        if (this.props.isAuthenticated) {
            this.props.onActionOpen(itemSlug);
        } else {
            this.props.loginClick(() => this.actionHandleClick(itemSlug));
        }
    }

    renderGarageSection() {
        return (
            this.props.isAuthenticated && (
                <TransactionActionDetails>
                    <GarageContainer
                        isOpen={this.props.stateActionsOpen.garage}
                        isNewEnabled={this.props.isNewEnabled}
                        isUsedEnabled={this.props.isUsedEnabled}
                        usedUrl={this.props.usedUrl}
                        timeSaved={this.props.timeSaved}
                        tradeInAmount={this.props.tradeInAmount}
                        tradeInTaxCredits={this.props.tradeInTaxCredits}
                        dataTest="login.transaction.garage.details"
                        forceVehiclesFetch={this.state.forceVehiclesFetch}
                        isMultiDealerGarage={!!this.props?.isMultiDealerGarage}
                        hasAdobeTagging={this.props.hasAdobeTagging}
                    />
                </TransactionActionDetails>
            )
        );
    }

    renderTradeInSection() {
        const { vehicleTradein } = this.props;

        const cz = ContentZonesService.getContentZone(czGroup, 'bar.tradein.hascbb');
        const hasVehicleEvaluationValue = cz && cz.getValue();
        const hasCBB = hasVehicleEvaluationValue === 'true';
        const dataTestTradeIn = 'login.transaction.tradein.details';

        let vehicleAmountLabel = LocaleService.t(
            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.VEHICLE_AMOUNT_NA'
        );
        if (!isNil(vehicleTradein.amount) && vehicleTradein.amount > 0) {
            vehicleAmountLabel = LocaleService.t(
                'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.VEHICLE_AMOUNT',
                { amount: LocaleService.l(vehicleTradein.amount, CurrencyFormats.CURRENCY_0) }
            );
        }

        return (
            this.props.isAuthenticated && (
                <TransactionActionDetails timeSaved={this.props.timeSaved}>
                    {this.props.isCompleted ? (
                        <div data-test={dataTestTradeIn}>
                            <h3 className="sr-text is-bold">
                                {LocaleService.t(
                                    'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.TITLE'
                                )}
                            </h3>
                            <br />
                            {hasCBB &&
                                !isNil(vehicleTradein.amount) && (
                                    <p className="sr-text" dangerouslySetInnerHTML={{ __html: vehicleAmountLabel }} />
                                )}
                            <p className="sr-text">
                                {!isNil(vehicleTradein.make) &&
                                    !isNil(vehicleTradein.model) &&
                                    !isNil(vehicleTradein.year) &&
                                    !isNil(vehicleTradein.modelTrim) &&
                                    LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.VEHICLE',
                                        {
                                            make: vehicleTradein.make,
                                            model: vehicleTradein.model,
                                            year: vehicleTradein.year,
                                            modelTrim: vehicleTradein.modelTrim,
                                        }
                                    )}
                                {!isNil(vehicleTradein.odometer) &&
                                    LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.ODOMETER',
                                        { odometer: vehicleTradein.odometer }
                                    )}
                            </p>
                            <br />
                            {!isNil(vehicleTradein.make) &&
                                !isNil(vehicleTradein.model) &&
                                !isNil(vehicleTradein.year) &&
                                !isNil(vehicleTradein.modelTrim) && (
                                    <>
                                        {// Hide the edit trade-in button for selected organization Id
                                        !this.state.displayNewTradeIn && (
                                            <a
                                                className="sr-link edit-trade-in"
                                                href={LocaleService.t('TRANSACTION_PROGRESSION.TRADE_IN_URL', {
                                                    tradeId: vehicleTradein.tradeId,
                                                })}
                                                data-test="login.transaction.tradein.edit-redirection"
                                            >
                                                <icon className="icon-pencil" />
                                                <span>
                                                    {hasCBB
                                                        ? LocaleService.t('LOGIN.EDIT_CBB_TRADEIN')
                                                        : LocaleService.t('LOGIN.EDIT')}
                                                </span>
                                            </a>
                                        )}
                                        <a className="sr-link delete-trade-in" onClick={this.props.deleteTradeIn}>
                                            <icon className="icon-trash-can" />
                                            <span>{LocaleService.t('LOGIN.DELETE_TRADEIN')}</span>
                                        </a>
                                        <p className="sr-disclaimer">
                                            {LocaleService.t(
                                                'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.ESTIMATED_LEGAL_DISCLAIMER'
                                            )}
                                        </p>
                                    </>
                                )}
                            {// Hide the official trade-in evaluation button and text for selected Organization Id
                            !this.state.displayNewTradeIn && (
                                <>
                                    <hr />
                                    <div className="sr-text is-bold">
                                        {/* TODO: Put this back after official trade-in work in CRM
                                            LocaleService.t(
                                                'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.ESTIMATED_VALUE')}
                                            {
                                                    vehicleTradein.retail > 0 ? (
                                                        <span className="is-price">
                                                            {LocaleService.l(vehicleTradein.retail, CurrencyFormats.CURRENCY_0)}
                                                        </span>
                                                    ) : (
                                                        LocaleService.t('LOGIN.PENDING')
                                                    )
                                                */}
                                        {LocaleService.t(
                                            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_OFFICIAL.QUESTION_TITLE'
                                        )}
                                    </div>
                                    {/* TODO: Put this back after official trade-in work in CRM
                                        <br />
                                        <div className="sr-disclaimer">
                                            <icon className="icon-Warning is-warning" />
                                            &nbsp;{LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.WARNING')}
                                        </div> */}
                                    <button
                                        className="sr-button-1"
                                        onClick={this.onTradeInClick}
                                        data-test="login.transaction.tradein.official-evaluation-redirection"
                                    >
                                        {LocaleService.t(
                                            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.BUTTON_LABEL'
                                        )}
                                    </button>
                                    <p className="sr-disclaimer">
                                        {LocaleService.t(
                                            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.LEGAL_WARNING'
                                        )}
                                    </p>
                                </>
                            )}
                        </div>
                    ) : (
                        <div data-test={dataTestTradeIn}>
                            <h3 className="sr-text is-bold">
                                {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.TITLE')}
                            </h3>
                            <p className="sr-text">
                                {LocaleService.t(
                                    'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.SUBTITLE'
                                )}
                            </p>
                            <br />
                            <ul className="earnings_listing">
                                <li>
                                    <icon className="icon-Crochet sr-sucessColor" />
                                    {LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.ADVANTAGE_1'
                                    )}
                                </li>
                                <li>
                                    <icon className="icon-Crochet sr-sucessColor" />
                                    {LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.ADVANTAGE_2'
                                    )}
                                </li>
                                <li>
                                    <icon className="icon-Crochet sr-sucessColor" />
                                    {LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.ADVANTAGE_3'
                                    )}
                                </li>
                            </ul>
                            <br />
                            {hasCBB && (
                                <button
                                    className="sr-button-1"
                                    onClick={() => this.onTradeInClick(false)}
                                    data-test="login.transaction.tradein.create-redirection"
                                >
                                    {LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.OLD_BUTTON_LABEL_CBB'
                                    )}
                                </button>
                            )}
                            {// Hide the official trade-in evaluation button and text for selected Organization Id
                            !this.state.displayNewTradeIn && (
                                <>
                                    <button
                                        className="sr-button-outline-1"
                                        onClick={() => this.onTradeInClick(true)}
                                        data-test="login.transaction.tradein.official-evaluation-redirection"
                                    >
                                        {LocaleService.t(
                                            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.TAKE_ACTION'
                                        )}
                                    </button>
                                    <p className="sr-disclaimer">
                                        {LocaleService.t(
                                            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.LEGAL_WARNING'
                                        )}
                                    </p>
                                </>
                            )}
                        </div>
                    )}
                </TransactionActionDetails>
            )
        );
    }

    renderFinanceSection() {
        const financeButtonLabel = LocaleService.t(
            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.BUTTON_LABEL_APPLY'
        );

        const handleClick = () => {
            if (this.props.hasAdobeTagging) {
                AdobeService.eventTrigger(
                    ADOBE_TAGS.TRANSACTION_BAR_CTA(
                        CONSTANT.TRANSACTION.FINANCE.TITLE,
                        CONSTANT.TRANSACTION.FINANCE.APPLY_NOW
                    ),
                    'global-onclick'
                );
            }
        };

        const financeButton = (
            <a
                className="sr-button-outline-1"
                title={financeButtonLabel}
                href={REDIRECTIONS[LocaleService.getSimpleLocale()].financing}
                onClick={handleClick}
            >
                {financeButtonLabel}
            </a>
        );
        return (
            this.props.isAuthenticated && (
                <TransactionActionDetails timeSaved={this.props.timeSaved}>
                    {this.props.isCompleted ? (
                        <div data-test="login.transaction.finance.details">
                            <FinancingState />
                        </div>
                    ) : (
                        <div data-test="login.transaction.finance.details">
                            <h3 className="sr-text is-bold">
                                {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.TITLE')}
                            </h3>
                            <p className="sr-text">
                                {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.SUBTITLE')}
                            </p>
                            <br />
                            <ul className="earnings_listing">
                                <li>
                                    <icon className="icon-Crochet sr-sucessColor" />
                                    &nbsp;{LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.ADVANTAGE_1'
                                    )}
                                </li>
                                <li>
                                    <icon className="icon-Crochet sr-sucessColor" />
                                    &nbsp;{LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.ADVANTAGE_2'
                                    )}
                                </li>
                            </ul>
                            <br />
                            {financeButton}
                        </div>
                    )}
                </TransactionActionDetails>
            )
        );
    }

    renderReservationSection() {
        return (
            this.props.isAuthenticated && (
                <TransactionActionDetails>
                    <GarageContainer
                        isOpen={this.props.stateActionsOpen.garage}
                        isNewEnabled={this.props.isNewEnabled}
                        isUsedEnabled={this.props.isUsedEnabled}
                        usedUrl={this.props.usedUrl}
                        timeSaved={this.props.timeSaved}
                        tradeInAmount={this.props.tradeInAmount}
                        tradeInTaxCredits={this.props.tradeInTaxCredits}
                        dataTest="login.transaction.reservation.details"
                        isReservationMode
                        isMultiDealerGarage={!!this.props?.isMultiDealerGarage}
                        hasAdobeTagging={this.props.hasAdobeTagging}
                    />
                </TransactionActionDetails>
            )
        );
    }

    render() {
        const { itemSlug } = this.props;

        const icon = ContentZonesService.getContentZone('widget.transaction', `${itemSlug}.icon`).getValue();
        const label = ContentZonesService.getContentZone('widget.transaction', `${itemSlug}.label`).getValue();

        const actionDetailsRender = {};
        actionDetailsRender.garage = this.renderGarageSection();
        actionDetailsRender.tradein = this.renderTradeInSection();
        actionDetailsRender.finance = this.renderFinanceSection();
        actionDetailsRender.reserve = this.renderReservationSection();

        const isActionValidate = this.props.isCompleted;
        const isActionWarning = false;
        const classNames = ['TransactionAction--single'];

        if (this.props.isCompleted) {
            classNames.push('is-validate');
        }

        if (this.props.stateActionsOpen[itemSlug]) {
            classNames.push('is-active');
        }
        return (
            <div className={classNames.join(' ')}>
                <button
                    onClick={() => this.actionHandleClick(itemSlug)}
                    data-test={`login.transaction.${itemSlug}.open`}
                >
                    {itemSlug === 'garage' &&
                        this.props.isAuthenticated && (
                            <div className="TransactionAction--single__amount sr-button-1 is-small">
                                {this.props.garageCount}
                            </div>
                        )}
                    <img src={icon} alt={label} />
                    <div className="label">
                        {isActionValidate && <icon className="icon-Crochet sr-sucessColor" />}
                        {isActionWarning && <icon className="icon-Warning is-warning" />}
                        {label}
                    </div>
                </button>
                <div
                    className={`TransactionAction--details ${
                        this.props.stateActionsOpen[itemSlug] ? 'is-visible' : ''
                    }`}
                >
                    {actionDetailsRender[itemSlug]}
                </div>
            </div>
        );
    }
}

TransactionAction.propTypes = {
    itemSlug: PropTypes.string.isRequired,
    garageCount: PropTypes.number.isRequired,
    isCompleted: PropTypes.bool,
    stateActionsOpen: PropTypes.shape({
        garage: PropTypes.bool.isRequired,
        tradein: PropTypes.bool.isRequired,
        finance: PropTypes.bool.isRequired,
    }).isRequired,
    onActionOpen: PropTypes.func.isRequired,
    isNewEnabled: PropTypes.bool.isRequired,
    isUsedEnabled: PropTypes.bool.isRequired,
    usedUrl: PropTypes.string.isRequired,
    tradeInAmount: PropTypes.number.isRequired,
    tradeInTaxCredits: PropTypes.number.isRequired,
    timeSaved: PropTypes.number,
    vehicleTradein: PropTypes.shape({
        tradeId: PropTypes.string.isRequired,
        make: PropTypes.string.isRequired,
        model: PropTypes.string.isRequired,
        modelTrim: PropTypes.string.isRequired,
        year: PropTypes.number.isRequired,
        odometer: PropTypes.number.isRequired,
        retail: PropTypes.number.isRequired,
        amount: PropTypes.number.isRequired,
    }).isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    loginClick: PropTypes.func.isRequired,
    deleteTradeIn: PropTypes.func.isRequired,
    isMultiDealerGarage: PropTypes.bool.isRequired,
    hasAdobeTagging: PropTypes.bool,
};

TransactionAction.defaultProps = {
    timeSaved: 0,
    isCompleted: false,
    isMultiDealerGarage: false,
    hasAdobeTagging: false,
};

TransactionAction.displayName = 'TransactionAction';

export default TransactionAction;
